
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sound-packages/free",
      function () {
        return require("private-next-pages/sound-packages/free/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sound-packages/free"])
      });
    }
  